import {takeEvery, takeLatest, put, all} from 'redux-saga/effects';
import {push} from 'react-router-redux';
import {fetchItemSaga} from './common-sagas';
import types from '../actions/types';
import {storeToken} from '../utils/local-storage';


function* getCurrentUserSaga() {
    yield fetchItemSaga('/api/user/', types.GET_CURRENT_USER);
}

function* logoutSaga() {
    storeToken('');
    yield put(push('/login/'));
}

function* getCurrentUserFailure() {
    storeToken('');
    yield put(push('/login/'));

}

export default function* userSagas() {
    yield all([
        takeEvery(types.GET_CURRENT_USER.REQUEST, getCurrentUserSaga),
        takeEvery(types.GET_CURRENT_USER.FAILURE, getCurrentUserFailure),

        takeLatest(types.LOGOUT, logoutSaga),
    ]);
}



// WEBPACK FOOTER //
// ./src/js/sagas/user-sagas.js